import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="combined-schools-certificate-applications"
export default class extends Controller {
  static targets = ["bulkQuantityJ", "bulkQuantityE", "quantityJ", "quantityE"];

  bulkApplyJ() {
    if (this.bulkQuantityJTarget.value) {
      this.quantityJTargets.forEach(
        (x) => (x.value = this.bulkQuantityJTarget.value)
      );
    }
  }

  bulkApplyE() {
    if (this.bulkQuantityETarget.value) {
      this.quantityETargets.forEach(
        (x) => (x.value = this.bulkQuantityETarget.value)
      );
    }
  }
}
